import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { EditOrganizationPayload, EditOrganizationInput } from './generated/types';

const mutation = `mutation MyQuery($input: EditOrganizationInput!) {
    editOrganization(input: $input) {
        id
    }
}
`;

export interface EditOrganizationVariables extends Omit<EditOrganizationInput, 'orgId'> {
    // lets the caller decide whether the org list view's cached names are stale
    hasNameChanged: boolean;
}

export const useEditOrganization = (orgId: string) => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ hasNameChanged, ...organizationData }: EditOrganizationVariables) => {

            const input: EditOrganizationInput = {
                orgId,
                ...organizationData,
            };

            await (context.api.graphql({
                query: mutation,
                variables: { input },
            }) as Promise<{
                data: {
                    editOrganization: EditOrganizationPayload;
                };
            }>);
        },
        onSuccess: async (_data, variables) => {
            // must be awaited so callers only see success after the refetched org data is in the cache
            await Promise.all([
                variables.hasNameChanged ? queryClient.invalidateQueries({ queryKey: ['listOrganizations'] }) : Promise.resolve(),
                queryClient.invalidateQueries({ queryKey: ['getOrganization', orgId] }),
            ]);
        },
    },
    );
};